import {
  checkValidEmail,
  checkValidCF,
} from '@redturtle/volto-io-prenoto/helpers';

// STATUS OPTION, values find in redturtle.prenotazioni rest api prenotazioni_workflow definition
export const BOOKING_STATUS_REFUSED = 'refused';

// la label attualmente è usata solo per la selectinput in "PrenotazioneTableResults.jsx" valutare
// in futuro se usare un vocabolario lato backend
export const STATUS_OPTIONS = {
  pending: {
    value: 'pending',
    label: 'In attesa',
    color: 'warning',
  },
  confirmed: {
    value: 'confirmed',
    label: 'Confermato',
    action: 'confirm',
    color: 'success',
  },
  refused: {
    value: 'refused',
    label: 'Rifiutato',
    action: 'refuse',
    color: 'danger',
  },
  restore: {
    value: 'restore',
    label: 'Ripristina',
    action: 'restore',
  },
  canceled: {
    value: 'canceled',
    label: 'Annullato',
    action: 'cancel',
    color: 'danger',
  },
};

// options based on the booking current status
export const getCurrentStatusOptions = (activeStatus) => {
  switch (activeStatus) {
    case 'pending':
      return [
        STATUS_OPTIONS.pending,
        STATUS_OPTIONS.confirmed,
        STATUS_OPTIONS.refused,
      ];
    case 'confirmed':
      return [STATUS_OPTIONS.confirmed, STATUS_OPTIONS.refused];
    case 'refused':
      return [STATUS_OPTIONS.refused, STATUS_OPTIONS.restore];
    default:
      return [];
  }
};

// get status value by label from STATUS_OPTIONS
export const getStatusOption = (status) => {
  return STATUS_OPTIONS[status];
};

// Return options of booking_type list
export const getBookingTypesOptions = (content) => {
  const typeOptions = [];
  if (content.booking_types && content.booking_types.length > 0) {
    content.booking_types.map((item) => {
      typeOptions.push({
        value: item.name,
        label: `${item.name} (${item.duration} min)`,
        hidden: item.hidden,
        duration: parseInt(item.duration),
      });
    });
  }
  return typeOptions;
};

export const getBookableTypesOptions = (list = []) =>
  list.map((el) => {
    return {
      value: el.id || el.name,
      label: `${el.name} ${el.duration ? `(${el.duration} minuti)` : ''}`,
    };
  });

// Return options of gate list
export const getGateOptions = (content) => {
  const gateOptions = [];
  if (content.gates && content.gates.length > 0) {
    content.gates.map((item) => {
      gateOptions.push({
        value: item,
        label: item,
      });
    });
  }
  return gateOptions;
};

/* Change prenotazione field */
export const changeBookingField = (fields = [], name, value) => {
  let found = false;

  fields.forEach((f) => {
    if (f.name == name) {
      f.value = value;
      found = true;
    }
  });

  if (!found) {
    fields.push({ name: name, value: value });
  }

  return fields;
};

/* Check if required input fields are populated.
    Return false if is invalid (there are required fields not populated) */
export const validBookingFields = (booking, schema) => {
  if (!booking) {
    return false;
  }
  const isOutOffice = booking?.booking_type === 'out-of-office';

  if (isOutOffice) {
    if (!booking?.duration || description === '') {
      return false;
    }
  }
  if (!booking?.booking_type) {
    return false;
  }
  if (booking.description === '') {
    return false;
  }
  if (schema.length > 0) {
    return (
      schema.filter((field) => {
        const value = booking?.[field.name];

        return field.name === 'email'
          ? field.required && (value === '' || checkValidEmail(value) === false)
          : field.name === 'fiscalcode'
            ? field.required && (value === '' || checkValidCF(value) === false)
            : field.required && value === '';
      }).length <= 0
    );
  }
  return true;
};
